import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MenuService } from 'src/app/services/heading-service';

@Component({
    selector: 'app-search',
    imports: [CommonModule, MatInputModule, MatIconModule, FormsModule],
    templateUrl: './search.component.html',
    styleUrl: './search.component.scss'
})
export class SearchComponent {
  @Input()
  useService: boolean = true;

  @Output()
  searchClicked: EventEmitter<string> = new EventEmitter<string>();

  @Output()
  clearClicked: EventEmitter<void> = new EventEmitter<void>();

  searchTerm: string = '';

  constructor(private menuService: MenuService) { }

  clearSearch() {
    if (this.useService)
      this.menuService.clearSearch();
    this.clearClicked.emit();
    this.searchTerm = '';

  }

  search() {
    if (this.useService) {
      this.menuService.setSearch(this.searchTerm || '');
    }
    this.searchClicked.emit(this.searchTerm);
  }
}